<template>
  <div class="bg-white-wrapper">
    <div class="container payment-wrapper">
      <h3 class="payment-header">
        <img src="../../assets/images/pay-logo-wxt.png" />
      </h3>
      <div class="payment-info">
        <div class="payment-order">
          <p>
            <b>订单编号：</b>
            <span>{{ orderInfo.orderNo }}</span>
          </p>
          <p>
            <b>商品名称：</b>
            <span>{{ orderInfo.productName }}</span>
          </p>
          <p>
            <b>应付总额：</b>
            <span class="payment-money"
              >￥{{ Number(orderInfo.orderMoney).toFixed(2) }}</span
            >
          </p>
        </div>
        <div class="payment-qrcode">
          <div class="payment-qrcode-box">
            <p>扫一扫，向我付款</p>
            <p>
              <span id="qrcode">
                <vue-qr
                  :margin="10"
                  :size="220"
                  :text="appQrcodeText"
                  style="display: block"></vue-qr>
                <!-- <img
                  src="http://m.beegoedu.com/tongguangpay/getPayBarCode.do?orderNo=@(ViewBag.OrderNos)"
                  width="220"
                  height="220"
                  alt="付款二唯码"
                  class="qrcode"
                />-->
              </span>
            </p>
          </div>
          <div class="payment-qrcode-logo">
            <img src="../../assets/images/pay-logo-wx.png" />
            <p>请使用微信扫码支付</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { getOrderInfo, removeOrderInfo } from '../../utils/localStorage';
import { order } from '../../request';
import VueQr from 'vue-qr';
export default {
  mixins: [siteMixin],
  data() {
    return {
      orderInfo: {
        orderNo: '',
        orderMoney: 0,
        productName: '',
      },
      appQrcodeText: '',
    };
  },
  mounted() {
    this.initOrderInfo();
    this.getPayData();
    this.taskPayIsSuccess();
  },
  beforeDestroy() {
    if (this.task) {
      clearInterval(this.task);
    }
  },
  methods: {
    initOrderInfo() {
      this.orderInfo = getOrderInfo();
    },
    getPayData() {
      order
        .paymentWithWx(this.loginUser.userId, this.orderInfo.orderNo)
        .then(res => {
          //console.log(res);
          if (res.status == 1) {
            this.appQrcodeText = res.data.code_url;
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    taskPayIsSuccess() {
      this.task = setInterval(() => {
        order.getOrderPayStatus(this.orderInfo.orderNo).then(res => {
          if (res.status === 1) {
            removeOrderInfo();
            clearInterval(this.task);
            this.$router.push({ name: 'PaymentSuccess' });
          }
        });
      }, 2000);
    },
  },
  components: {
    VueQr,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var';
.payment-wrapper {
  padding: 10px 0;
  .payment-header {
    color: #000;
    font-size: 2rem;
    font-weight: normal;
    padding: 1.6rem 0;
    img {
      width: 232px;
      height: 36px;
    }
  }
  .payment-info {
    padding: 30px 50px;
    background-color: #fff;
    border: 1px solid #f0f0f0;
    text-align: left;
    .payment-order {
      margin-top: 1.6rem;
      p {
        line-height: 3rem;
        .payment-money {
          font-size: 2.4rem;
          color: #1296db;
        }
      }
    }
    .payment-qrcode {
      margin-top: 3rem;
      .payment-qrcode-box {
        width: 350px;
        height: 350px;
        background-color: #2ead38;
        margin: 0 auto;
        p {
          text-align: center;
          &:first-child {
            font-size: 20px;
            color: #fff;
            padding-top: 20px;
          }
          &:last-child {
            margin: 25px auto 0 auto;
            width: 220px;
            height: 220px;
            border-radius: 10px;
            overflow: hidden;
            background: #fff;
            position: relative;
            span {
              position: absolute;
              left: 0;
              top: 0;
              width: 220px;
              height: 220px;
              z-index: 2;
            }
          }
        }
      }
      .payment-qrcode-logo {
        margin-top: 1.6rem;
        text-align: center;
        img {
          display: inline-block;
          height: 60px;
        }
        p {
          font-size: 22px;
          text-align: center;
          color: #135997;
          margin-top: 15px;
        }
      }
    }
  }
}
.stage-helper {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
